// extracted by mini-css-extract-plugin
module.exports = {"close":"SizeGuideModal_close__bssf2","table":"SizeGuideModal_table__QAFll"};